import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { App as CapacitorApp } from '@capacitor/app';
import StructureService from '../services/structure-service';
import MainService from '../services/main-service';

const useCapacitorAppUrlOpen: Function = (): void => {
  const navigate: ReactRouterNavigate = useNavigate();

  const mainAppHost: string | undefined = MainService.MAIN_APP_HOST;
  const customAppHost: string | undefined = MainService.CUSTOM_APP_HOST;

  useEffect((): void => {
    async function addCapacitorListener(): Promise<void> {
      await CapacitorApp.addListener('appUrlOpen', (event: CapacitorUrlOpenListenerEvent): void => {
        let route: string | undefined = event.url;

        if (route && mainAppHost) {
          route = route.replace(mainAppHost, '');
        }

        if (route && customAppHost) {
          route = route.replace(customAppHost, '');
        }

        if (route) {
          navigate(route);
        }
      });
    }

    addCapacitorListener().then(StructureService.emptyAction);
  }, []);
};

export default useCapacitorAppUrlOpen;
